import { render, staticRenderFns } from "./Calculator.vue?vue&type=template&id=4051b652&scoped=true&shadow"
import script from "./Calculator.vue?vue&type=script&lang=js&shadow"
export * from "./Calculator.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./Calculator.vue?vue&type=style&index=0&id=4051b652&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4051b652",
  null
  ,true
)

export default component.exports